module.exports = "/packs/media/images/Meeting_3-653bfd1046a4e1362937d7d79fa3c46c.jpg";